export const MASTERS_SEARCH_SHOW_MAP_DRAGGABLE_MARKER = false;
